<template lang="pug">
.ride-word 购买{{tabCode==='bike'?'单车':'助力车'}}卡
</template>
<script>
import { ParamsUtil } from '../../../../../utils/params';

export default {
  created() {
    const {
      tabCode,
    } = ParamsUtil.getParams(window.location.href);
    this.tabCode = (tabCode || 'bike');
  },
};
</script>
<style lang="less" scoped>
.ride-word {
  padding-top: 0.07rem;
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  font-size: 0.16rem;
  font-weight: 500;
  color: #000;
  margin-left: 0.2rem;
  line-height: 0.224rem;
  margin-bottom: 0.15rem;
}
</style>
